<template>
  <cf-progress-ring
    v-if="loyalty.finalThreshold"
    :label="loyalty.currency.pluralShortNameUpperCase"
    :progress="loyalty.currentBalance"
    :steps="loyalty.finalThreshold.cost"
  />
</template>

<script>
  import { mapGetters } from 'vuex';

  import CfProgressRing from '../cf-progress-ring/index.vue';

  export default {
    name: 'CfLoyaltyProgressRing',

    components: {
      CfProgressRing
    },

    computed: {
      ...mapGetters('offers', ['loyalty']),

      checkpoints() {
        if (!this.loyalty.isMultiTiered) {
          return [];
        }

        const checkpoints = this.loyalty.allThresholds.map(threshold => ({
          content: `${threshold.rewardOffer.title} <span class="tag tag--inline">${threshold.cost} ${this.loyalty.currency.pluralShortNameUpperCase}</span>`,
          value: threshold.cost
        }));

        return checkpoints;
      }
    }
  };
</script>
